const REGIONS = [
	{ country: "Americas", continents: ["North America", "South America"] },
	{ country: "Europe & Africa", continents: ["Europe", "Africa"] },
	{ country: "Asia Pacific", continents: ["Asia", "Oceania"] },
];

export function groupClientLocations(locations) {
	return REGIONS.map((region) => {
		const members = locations.filter((location) => region.continents.includes(location.continent));
		if (!members.length) return null;
		const points = members;
		const xs = points.map((point) => point.x);
		const ys = points.map((point) => point.y);
		return {
			country: region.country,
			headingSide: region.country === "Americas" ? "right" : "left",
			headingY: region.country === "Asia Pacific" ? 0.16 : 0.09,
			label: "CLIENT LOCATIONS",
			description: members.map((location) => location.country).join(" · "),
			point_label: "SUPPORTED FROM GUJARAT",
			codes: members.map((location) => location.code),
			x: (Math.min(...xs) + Math.max(...xs)) / 2,
			y: (Math.min(...ys) + Math.max(...ys)) / 2,
			width: Math.max(...xs) - Math.min(...xs) + 140,
			height: Math.max(...ys) - Math.min(...ys) + 130,
		};
	}).filter(Boolean);
}
